<template>
    <div>
        <b-modal
                ref="popupShowMedia"
                hide-footer
                size="xl"
                class="modal-xl "
                body-class=" modal-xl bg-white p-0"
                :title="trip  ? trip.short_desc :  ''"
                v-on:close="onClose"
                v-on:cancel="onClose"
                v-on:hide="onClose"
                @cancel="onClose"
                @close="onClose">

            <b-container v-if="currentImage" class="nopadding">
                <b-row>
                    <b-col lg="8" class="nopadding">


                        <LightBox
                                ref="imgGallery"
                                :showLightBox="true"
                                :showCaption="true"
                                :startAt="lightBoxImagesIndex"
                                :images="lightBoxImages"
                                v-on:image-changed="onLightBoxImageChanged"
                        >
                            <div slot="close"></div>
                        </LightBox>


                        <div v-for="(face, i) in faces"
                             class=""
                             v-bind:class="{'faces' : face.show}"
                             :style="'position: absolute;' +
                                        'left: '+ face.left + 'px;' +
                                        'top: '+ face.top + 'px;' +
                                        'width: '+ face.width + 'px;' +
                                        'height: '+ face.height + 'px;'"
                             @mouseover="showFace(face)"
                             @mouseleave="hideFace(face)"
                        >
                            <span
                                    v-show="face.show"
                                    class="ml-1 circle bg-success text-white fw-bold">
                                {{i+1}}
                            </span>
                        </div>


                    </b-col>
                    <b-col lg="4">

                        <photos-localisation
                                ref="photoLoc"
                                :albumImages="images"
                                :image="currentImage"
                                :trip="trip"
                                :read-only="editMode !== 'location'"
                                v-on:close="closeSetPosition">


                            <div id="wrapper">
                                <div id="mapPhotoLocalisation" style="padding:0px;width:100%; height:200px"></div>

                                <div id="over_map" v-if="isOwner">
                                    <a href="#"
                                       class="btn width-100 btn-xs mr-xs btn-info"
                                       @click="onLocationEdit"
                                       v-if="editMode !== 'location'">
                                        <span v-if="Math.abs(currentImage.latitude + currentImage.longitude) > 0.1">

                                            <i class="fa fa-map-marker fa-lg"/> Edit
                                        </span>
                                        <span v-else>

                                            <i class="fa fa-map-marker fa-lg"/> Add location
                                        </span>
                                    </a>
                                    <a href="#"
                                       class="btn width-100 mb-xs mr-xs btn-info"
                                       @click="onLocationSave"
                                       v-if="editMode === 'location'">
                                        <span v-if="editMode">
                                            <i class="fa fa-map-marker fa-lg"/> Save
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </photos-localisation>

                        <div v-if="editMode === 'description'">
                            <textarea-autosize
                                    ref="textareaImageDescription"
                                    v-model="currentImage.description"
                                    placeholder="Add description" :rows="3"
                                    class="form-control"
                                    style="min-height:50px"
                            />

                            <a href="#"
                               class="btn width-100 btn-xs mr-xs btn-info"
                               @click="onDescriptionSave"
                            >
                                <i class="fa fa-pen fa-lg"/> Save
                            </a>
                        </div>

                        <p v-if="editMode !== 'description'"
                           style="white-space: pre;">{{currentImage.description}}</p>

                        <ul class="postLinks imgLinks">
                            <li>
                                <Likes :object-id="currentImage.id" type="link"></Likes>
                            </li>

                            <li v-if="editMode !== 'description'">
                                <a

                                        @click="onDescriptionEdit"
                                >
                                    <span v-if="currentImage.description.length">Edit description</span>
                                    <span v-if="currentImage.description.length === 0">Add description</span>

                                </a>
                            </li>

                            <li><a href="#">Comment</a></li>
                        </ul>
                        <comments-thread
                                ref="commentThread"
                                :thread-id="currentImage.id"
                                thread-collection="medias"
                                v-on:parent-comment-added="onCommentAdded"
                                v-on:child-comment-added="onCommentAdded">
                        </comments-thread>

                    </b-col>

                </b-row>
            </b-container>
        </b-modal>


    </div>
</template>


<script>
  import PhotosLocalisation from '../PhotosLocalisation/PhotosLocalisation'
  import Likes from '@/components/Likes/Likes'

  import CommentsThread from '@/components/Comments/CommentsThread'
  import LightBox from '@/components/LightBox/LightBox'

  import UIHelpersMixins from '@/mixims/UIHelpersMixins'

  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')

  export default {
    name:       'ShowPhotosModal',
    mixins:
                [
                  UIHelpersMixins,
                ],
    components: {
      PhotosLocalisation,
      Likes,
      CommentsThread,
      LightBox,
    },

    props:    [
      'images',
      'trip',
    ],
    data ()
    {
      return {
        faces:               [],
        editMode:            null,
        lightBoxImages:      [],
        lightBoxImagesIndex: null,
      }
    },
    mounted ()
    {

    },
    filters:  {},
    computed: {
      currentImage ()
      {
        if (this.lightBoxImages.length === 0)
        {
          return null
        }

        return this.lightBoxImages[this.lightBoxImagesIndex]
      },
      nextImage ()
      {
        if (this.lightBoxImages.length === 0)
        {
          return null
        }

        var nextIndex = (this.lightBoxImagesIndex + 1) % this.lightBoxImages.length

        return this.lightBoxImages[nextIndex]
      },
      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },
      isOwner ()
      {
        return this.currentImage && this.currentUser.uid === this.currentImage.uid
      },
    },
    methods:  {

      showFace (face)
      {
        face.show = true
      },
      hideFace (face)
      {
        face.show = false
      },
      updateFaces ()
      {

        var that           = this
        var originalWidth  = null
        var originalHeight = null

        this.currentImage.faces = this.currentImage.faces || {}

        if (
          this.currentImage.metadata.originalImage &&
          this.currentImage.metadata.originalImage.dimensions &&
          this.currentImage.metadata.originalImage.dimensions.width)
        {
          originalWidth  = this.currentImage.metadata.originalImage.dimensions.width
          originalHeight = this.currentImage.metadata.originalImage.dimensions.height
        }

        that.faces = []

        if (!originalWidth)
        {
          return
        }


        this.currentImage.faces.forEach(function (face) {

          var b, l, w, h
          l = Number.MAX_SAFE_INTEGER
          b = Number.MAX_SAFE_INTEGER
          w = 0
          h = 0

          var vertices    = face.boundingPoly.vertices
          var rotatePoint = function (w, h, point, theta) {

            theta = theta * Math.PI / 180
            var x = point.x
            var y = point.y

            x = x - w / 2
            y = y - h / 2

            var x2 = x * Math.cos(theta) - y * Math.sin(theta)
            var y2 = y * Math.cos(theta) + x * Math.sin(theta)

            var x3 = x2 + h / 2
            var y3 = y2 + w / 2

            return {
              x: Math.round(x3),
              y: Math.round(y3)
            }
          }

          setTimeout(function () {

            var frameW = that.$refs.imgGallery.$el.clientWidth
            var imgW   = that.$refs.imgGallery.$el.getElementsByTagName('img')[0].clientWidth
            var imgH   = that.$refs.imgGallery.$el.getElementsByTagName('img')[0].clientHeight
            var origH  = that.currentImage.metadata.originalImage.dimensions.height
            var origW  = that.currentImage.metadata.originalImage.dimensions.width
            var f      = {
              show: false
            }

            if (
              that.currentImage.metadata.originalImage.dimensions.width > that.currentImage.metadata.originalImage.dimensions.height &&
              that.currentImage.metadata.originalImage.dimensions.orientation !== 8 && that.currentImage.metadata.originalImage.dimensions.orientation !== 6)
            {
              var scaleFactorW = imgW / originalWidth

              f.left   = scaleFactorW * vertices[0].x
              f.top    = scaleFactorW * vertices[0].y
              f.width  = scaleFactorW * (vertices[2].x - vertices[0].x)
              f.height = scaleFactorW * (vertices[2].y - vertices[0].y)
              that.faces.push(f)
            } else
            {
              vertices[0] = rotatePoint(originalWidth, originalHeight, vertices[0], 90)
              vertices[1] = rotatePoint(originalWidth, originalHeight, vertices[1], 90)
              vertices[2] = rotatePoint(originalWidth, originalHeight, vertices[2], 90)
              vertices[3] = rotatePoint(originalWidth, originalHeight, vertices[3], 90)

              var scaleFactorH = imgH / originalHeight
              var scaleFactorW = imgW / originalWidth

              f.left   = (vertices[3].y / origW) * imgW + (frameW - imgW) / 2
              f.top    = scaleFactorH * (origH - vertices[3].x - (vertices[1].x - vertices[3].x))
              f.width  = scaleFactorH * (vertices[1].y - vertices[3].y)
              f.height = scaleFactorH * (vertices[1].x - vertices[3].x)
              that.faces.push(f)
            }
          }, 666)

        })
      },
      onCommentAdded (ref)
      {

      },
      show (index)
      {
        var that = this
        that.$refs.popupShowMedia.show()

        that.lightBoxImagesIndex = index

        this.preload(index + 1)

        setTimeout(function () {
          console.log('show')
          if (that.$refs.imgGallery)
          {
            that.$refs.imgGallery.showImage(index)
          }

          that.updateFaces()
        }, 0)
      },

      preload (index)
      {
        if (index > this.lightBoxImages.length)
        {
          return
        }

        var nextImage = this.lightBoxImages[index]

        if (!nextImage)
        {
          return
        }

        const image = new Image()

        image.src = nextImage.src

      },
      reload ()
      {
        this.editMode = null

        this.lightBoxImages = this.$props.images
        //  this.lightBoxImagesIndex = this.$props.index

        if (!this.currentImage)
        {
          return
        }

        //  this.show()
      },
      onLocationEdit ()
      {
        this.editMode = 'location'
      },
      onDescriptionEdit ()
      {
        this.editMode = 'description'
        var that      = this
        setTimeout(function () {
          that.$refs.textareaImageDescription.$el.focus()

        }, 100)
      },
      onDescriptionSave ()
      {
        var that      = this
        this.editMode = null

        fb.mediasCollection.doc(this.currentImage.id).update({
          updatedOn:     new Date(),
          'description': this.currentImage.description,
        }).then(() => {
          that.notifyVue('success', 'Photo description  Saved ! Yay!')
          //that.$emit('close')
        })

      },
      onLocationSave ()
      {
        this.editMode = null

        this.$refs.photoLoc.acceptSetPosition()
      },
      onClose ()
      {
        this.$emit('close')
      },
      closeSetPosition ()
      {

      },
      onLightBoxImageChanged (index)
      {
        this.editMode = null

        this.preload(index + 1)

        this.lightBoxImagesIndex = index

        let image = this.lightBoxImages[index]
        console.log(image)

        this.updateFaces()
        this.$emit('image-changed', image)
      },
    },
    watch:    {
      images: function (newval, oldVal) { this.reload()},
      index:  function (newval, oldVal) { this.reload()},
    },

  }

</script>

<style type="scss">
    .imgLinks {
        background-color: #f8f9fa;
        /* margin: 20px -20px 0; */
        padding: 10px 20px;
    }

</style>
<style>
    #wrapper {
        position: relative;
    }

    #over_map {
        position: absolute;
        right: 30px;
        bottom: 10px;
        z-index: 99;
    }
</style>

<style type="css" scoped>
    .container >>> .vue-lb-container {
        position: static !important;
        background-color: #fff;
    }

    .container >>> .vue-lb-button-close {
        display: none;
    }

    .container >>> .vue-lb-footer-count {
        color: #000;

    }

    .row {
        margin-right: 0;
        margin-left: 0;
    }

    .modal-body {
        padding: 0;
    }

    .container >>> .vue-lb-thumbnail {
        display: none;
    }

    .container >>> .vue-lb-footer {
        display: none;
    }

    .container >>> .vue-lb-info {
        display: none;
    }

    .container >>> .vue-lb-header {
        display: none;
    }

    .container >>> .vue-lb-content {
        margin-bottom: 0;
    }

    .container >>> .vue-lb-container {

        padding: 0;
    }


    .container {
        max-width: 100% !important;
    }

    .nopadding {
        padding: 0;
    }

    .container >>> .vue-lb-arrow svg {
        fill: #ccc;
        opacity: 0.6;
        z-index: 1500;
    }

    .container >>> .vue-lb-arrow {
        z-index: 1500;
    }

    .faces {

        z-index: 1300;
        display: block;
        border: 1px dashed #eee
    }

</style>

<style type="css">

    @media (min-width: 992px) {
        .modal-xl {
            max-width: 800px !important;;
            padding: 0 !important;
        }
    }

    @media (min-width: 1200px) {
        .modal-xl {
            max-width: 1140px !important;
            padding: 0 !important;
        }
    }

    @media (min-width: 1600px) {
        .modal-xl {
            max-width: 1340px !important;
            padding: 0 !important;

        }
    }


</style>